import { useContext } from 'react';

import { CategoryFIlter } from './CategoryFilter/CategoryFilter';

import { GoodsListContext } from '../../Context/GoodsListContext';

export const CategoryFIltersList = () => {
  const {
    state: {
      filters: { categories },
    },
    dispatch,
  } = useContext(GoodsListContext);

  const handleChange = (event) => {
    const activeInput = event.target.checked;

    if (activeInput) {
      dispatch({ type: 'filter-change', payload: { categories: [...categories, event.target.id] } });
    } else {
      dispatch({
        type: 'filter-change',
        payload: { categories: categories.filter((values) => values !== event.target.id) },
      });
    }
  };

  return (
    <div className="mt-2 md:mt-4">
      <h3 className="font-crimson font-bold text-base md:text-lg leading-5">Categories</h3>
      <div>
        {['Clothes', 'Books', 'Wands', 'Quidditch', 'Sweets', 'Travel', 'Toys', 'Souvenirs'].map((category, idx) => (
          <CategoryFIlter
            key={category + idx}
            name={category}
            handleFilter={handleChange}
            isActive={categories.includes(category)}
          />
        ))}
      </div>
    </div>
  );
};
